import { render, staticRenderFns } from "./Dstudent.vue?vue&type=template&id=c1df8bbe"
import script from "./Dstudent.vue?vue&type=script&lang=js"
export * from "./Dstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports